import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

import { PlanHelpers } from 'utils';
import { useEvents } from 'hooks';

const DetailInput = () => {
  const { farmerPlan } = useEvents();

  if (farmerPlan) {
    const InputComponent = PlanHelpers.getComponentForType(farmerPlan?.data?.plan_type);
    return (
      <Grid container item>
        {InputComponent ? <InputComponent /> : <div></div>}
      </Grid>
    );
  }

  return <div />;
};

export default DetailInput;

DetailInput.propTypes = {
  setExpanded: PropTypes.func,
};
